var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SectionWrapper',{attrs:{"title":_vm.title,"to":{ name: 'woori-crowd' },"subtitle":_vm.subtitle,"no-content":_vm.isExecuting}},[(_vm.investingWooriCrowd && !_vm.isExecuting)?_c('InvestingSection',{attrs:{"loan":_vm.investingWooriCrowd}}):(_vm.executedWooriCrowd)?_c('RepaymentSection',{attrs:{"loan":_vm.executedWooriCrowd}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }